import { render, staticRenderFns } from "./AboutIVYED.vue?vue&type=template&id=21919f9a&scoped=true&"
import script from "./AboutIVYED.vue?vue&type=script&lang=js&"
export * from "./AboutIVYED.vue?vue&type=script&lang=js&"
import style0 from "./AboutIVYED.vue?vue&type=style&index=0&id=21919f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21919f9a",
  null
  
)

export default component.exports